export default "__VITE_ASSET__7d412202__"